export const hasAccess = (
  userRole: string | undefined,
  rolesAllowed: string[],
  additionalCondition: boolean = true
): boolean => {
  return rolesAllowed.includes(userRole || "") && additionalCondition;
};